<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header common-modal__text-header-flex-none">
      {{addAlert.title}}
    </span>
  </div>
  @if (addAlert.steps.length) {
    <wizard-steps [steps]="addAlert.steps"
      [state]="addAlert.stepState">
    </wizard-steps>
  }
  <div class="common-modal__content">
    @if (addAlert.stepState === 2) {
      <p class="common-modal__content-header-info"
        afTranslate="add-alert.addressee-description">
      </p>
    }
    <form class="common-modal__form-container">
      @if (addAlert.stepState !== 3) {
        <div class="common-container__mandatory-obligatory-message-form">
          <span class="common-tag__mandatory-text-asterisk">*</span>
          <span class="common-tag__mandatory-label-text-obligatory-message"
            [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
        </div>
      }
      @switch (addAlert.stepState) {
        @case (1) {
          <field-type-text-simple [field]="addAlert.titleAlert"
            [preSelectItem]="addAlert.addAlert.name"
            (itemSelected)="itemName('name', $event.newValue)">
          </field-type-text-simple>
          @if (addAlert.referenceDate) {
            <field-type-date
              [field]="addAlert.fieldReferenceDate"
              [preSelectItem]="addAlert.addAlert.referenceDate"
              (itemSelected)="itemSelected('referenceDate', $event.newValue)">
            </field-type-date>
          }
          @if (addAlert.designType === 'process') {
            <field-type-list-simple
              [field]="addAlert.statesField"
              [listValues]="addAlert.processStates"
              [preSelectItem]="addAlert.addAlert.stateId"
              (itemSelected)="itemSelected('stateId', $event.newValue)">
            </field-type-list-simple>
          }
          @if (addAlert.designType === 'date' && addAlert.chargedAlertTypes) {
            <field-type-list-simple
              [field]="addAlert.whenField"
              [listValues]="addAlert.whenList"
              [preSelectItem]="addAlert.addAlert.when"
              (itemSelected)="itemSelected('when', $event.newValue)">
            </field-type-list-simple>
          }
          @if (addAlert.designType === 'document' && addAlert.chargedAlertTypes) {
            <field-type-list-extended
              [field]="addAlert.whenField"
              [listValues]="addAlert.whenList"
              [preSelectItem]="addAlert.addAlert.when"
              (itemSelected)="itemSelected('when', $event.newValue)">
            </field-type-list-extended>
          }
          @if((addAlert.addAlert.when && addAlert.designType === 'date') || addAlert.designType === 'process'){
            <div class="common-radio-button-list__container-box">
              <div class="common-text-input__block-header">
                <p class="common-text-input__label">
                  <span class="common-text-input__text-label"
                    [afTranslate]="'add-alert.notification-moment'">
                  </span>
                  <span class="common-tag__mandatory-text-asterisk">*</span>
                </p>
              </div>
              @if (addAlert.designType ==='date') {
                <div class="common-radio-button-list__switch-option-container">
                  @if(addAlert.addAlert.when === 1) {
                    <span class="common-radio-button-list__switch-option-text" [afTranslate]="'add-alert.warning-exact-day'"></span>
                    <input-time [input]="addAlert.addAlert.hour"
                      (output)="itemSelected('hour', $event.newValue)">
                    </input-time>
                  }@else {
                    <span class="common-radio-button-list__switch-option-text" [afTranslate]="'add-alert.warn'"></span>
                    <input-number [preSelectValue]="addAlert.addAlert.numDays"
                      (selectedValue)="itemSelected('numDays', $event.newValue)">
                    </input-number>
                    <button-with-text-menu-arrow
                      [item]="addAlert.buttonArrowItem"
                      [list]="addAlert.frecuencyList"
                      [selectedOption]="addAlert.addAlert.timeUnit"
                      (launchActionEmitter)="itemSelected('timeUnit', $event.option)">
                    </button-with-text-menu-arrow>
                    <span class="common-radio-button-list__switch-option-text"
                      [afTranslate]="addAlert.addAlert.when === 2 ? 'add-alert.at-before' : 'add-alert.at-later'">
                    </span>
                    <input-time [input]="addAlert.addAlert.hour"
                      (output)="itemSelected('hour', $event.newValue)">
                    </input-time>
                  }
                </div>
              }@else if (addAlert.designType === 'process') {
                <label for="process-step-selected"
                  class="common-radio-button-list__switch-option-container">
                  <input type="radio"
                    id="process-step-selected"
                    class="common-radio-button__no-input"
                    name="period"
                    value="1"
                    [(ngModel)]="addAlert.addAlert.when">
                    <div class="common-radio-button__size-sm">
                      <i class="common-icon__sm"
                        [ngClass]="addAlert.addAlert.when == 1?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                      </i>
                    </div>
                    <span class="common-radio-button-list__switch-option-text"
                      [afTranslate]="'add-alert.next-preselect-notification'">
                    </span>
                </label>
                <label for="process-next-period"
                  class="common-radio-button-list__switch-option-container">
                  <input type="radio"
                    id="process-next-period"
                    class="common-radio-button__no-input"
                    name="period"
                    value="2"
                    [(ngModel)]="addAlert.addAlert.when">
                  <div class="common-radio-button__size-sm">
                    <i
                      class="common-icon__sm"
                      [ngClass]="addAlert.addAlert.when == 2 ? 'lf-icon-radio-button-active common-radio-button__select-main' : 'lf-icon-step-first common-radio-button__un-select-grey'">
                    </i>
                  </div>
                  <span class="common-radio-button-list__switch-option-text"
                    [afTranslate]="'add-alert.exceeded-period-notification'">_Cuando se supere
                  </span>
                  <input-number [preSelectValue]="addAlert.addAlert.delayUnits"
                    (selectedValue)="itemSelected('delayUnits', $event.newValue)"
                    [disabled]="addAlert.addAlert.when != 2">
                  </input-number>
                  <button-with-text-menu-arrow
                    [item]="addAlert.buttonArrowItem"
                    [list]="addAlert.frecuencyList"
                    [disabled]="addAlert.addAlert.when != 2"
                    [selectedOption]="addAlert.addAlert.delayTimeUnit"
                    (launchActionEmitter)="itemSelected('delayTimeUnit', $event.option)">
                  </button-with-text-menu-arrow>
                  <span class="common-radio-button-list__switch-option-text"
                    [afTranslate]="'add-alert.in-origin-state'">_en el estado de origen
                  </span>
                </label>
              }
            </div>
          }

          <field-type-switch [field]="{label: 'add-alert.repeat'|afTranslate}"
            [preSelectItem]="addAlert.repeat"
            [small]="true"
            (itemSelected)="changeEditPattern($event.newValue)">
          </field-type-switch>
          @if (addAlert.repeat) {
            <div class="common-radio-button-list__container-box">
              <div class="common-text-input__block-header">
                <p class="common-text-input__label">
                  <span class="common-text-input__text-label"
                    [afTranslate]="'repeat-pattern.establish-pattern-title'">
                  </span>
                  <span class="common-tag__mandatory-text-asterisk">*</span>
                </p>
              </div>
              <label for="period-interval"
                class="common-radio-button-list__switch-option-container">
                <input type="radio"
                  id="period-interval"
                  class="common-radio-button__no-input"
                  name="period"
                  value="interval"
                  [(ngModel)]="addAlert.repeatInterval.period"
                  [ngModelOptions]="{standalone: true}">
                <div class="common-radio-button__size-sm">
                  <i class="common-icon__sm"
                    [ngClass]="addAlert.repeatInterval.period === 'interval'?
                      'lf-icon-radio-button-active common-radio-button__select-main'
                      :
                      'lf-icon-step-first common-radio-button__un-select-grey'">
                  </i>
                </div>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'add-alert.repeat-during'"
                    >_Repetir durante
                </span>
                <input-number [preSelectValue]="addAlert.repeatInterval.during"
                  (selectedValue)="intervalSelected('during', $event.newValue)"
                  [disabled]="addAlert.repeatInterval.period !== 'interval'">
                </input-number>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.days'">
                  _dia(s)
                </span>
              </label>
              <label
                for="period-frecuency"
                class="common-radio-button-list__switch-option-container">
                <input
                  type="radio"
                  id="period-frecuency"
                  class="common-radio-button__no-input"
                  name="period"
                  value="frecuency"
                  [(ngModel)]="addAlert.repeatInterval.period"
                />
                <div class="common-radio-button__size-sm">
                  <i
                    class="common-icon__sm"
                    [ngClass]="addAlert.repeatInterval.period === 'frecuency' ? 'lf-icon-radio-button-active common-radio-button__select-main' : 'lf-icon-step-first common-radio-button__un-select-grey'">
                  </i>
                </div>
                <span
                  class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.repeat-every'">
                  _Repetir cada
                </span>
                <input-number
                  [preSelectValue]="addAlert.repeatInterval.every"
                  (selectedValue)="intervalSelected('every', $event.newValue)"
                  [disabled]="addAlert.repeatInterval.period !== 'frecuency'">
                </input-number>
                <button-with-text-menu-arrow
                  [item]="addAlert.buttonArrowItem"
                  [list]="addAlert.frecuencyList"
                  [selectedOption]="addAlert.repeatInterval.everyTime"
                  [disabled]="addAlert.repeatInterval.period !== 'frecuency'"
                  (launchActionEmitter)="intervalSelected('everyTime', $event.option)">
                </button-with-text-menu-arrow>
                <button-with-text-menu-arrow
                  [item]="addAlert.buttonArrowEnding"
                  [list]="addAlert.frecuencyRepeatList"
                  [selectedOption]="addAlert.repeatInterval.ending"
                  [disabled]="addAlert.repeatInterval.period !== 'frecuency'"
                  (launchActionEmitter)="intervalSelected('ending', $event.option)">
                </button-with-text-menu-arrow>
              </label>

            </div>
          }
        }
        @case(2){
          @if (addAlert.contactsField) {
            <field-type-contacts
              [selectContextUser]="!configuration?.alert"
              [field]="addAlert.contactsField"
              [concept]="addAlert.concept"
              (sendContacts)="receiveContacts($event)"
              (contactsClosed)="contactsClosed()">
            </field-type-contacts>
          }
          @if (addAlert.showText) {
            <field-type-rich-text-editable
              [field]="addAlert.messageField"
              [preSelectItem]="addAlert.message"
              (itemSelected)="addAlert.message = $event.newValue">
            </field-type-rich-text-editable>
          }
        }
        @default {
          @if (addAlert.disabledNotifyToIdentifying && addAlert.showInfoMessage) {
            <advice-message
              class="pb-[40px]"
              [type]="'warning'"
              [text]="addAlert.warningText"
              [showCloseButton]="false"
              (closeAdvice)="closeAdvice('showInfoMessage')">
            </advice-message>
          }
          @else {
            <div>
              <div
                class="common-radio-button__radio-container"
                (click)="notifyToIdentifyingChanged(false)">
                <div
                  class="common-button__block-button-md-checkbox">
                  <button
                    type="button"
                    class="common-button__icon-md-checkbox"
                    [ngClass]="{'common-button__icon-md-checkbox--selected': !addAlert.notifyToIdentifying && !addAlert.customTemplateSwitch}">
                    <i
                      class="common-icon__md"
                      [ngClass]="!addAlert.notifyToIdentifying && !addAlert.customTemplateSwitch ? 'lf-icon-radio-button-active' : 'lf-icon-step-first'">
                    </i>
                  </button>
                </div>
                <span class="common-button__text-md-checkbox">
                  {{'add-alert.dont-send-notification' | afTranslate}}
                </span>
              </div>
              <div class="flex flex-col gap-xs">
                <div class="flex items-center">
                  <div
                    class="common-radio-button__radio-container"
                    (click)="notifyToIdentifyingChanged(true)">
                    <div class="common-button__block-button-md-checkbox">
                      <button
                        type="button"
                        class="common-button__icon-md-checkbox"
                        [ngClass]="{'common-button__icon-md-checkbox--selected': addAlert.notifyToIdentifying && !addAlert.customTemplateSwitch}">
                        <i
                          class="common-icon__md"
                          [ngClass]="addAlert.notifyToIdentifying && !addAlert.customTemplateSwitch ? 'lf-icon-radio-button-active' : 'lf-icon-step-first'">
                        </i>
                      </button>
                    </div>
                    <span class="common-button__text-md-checkbox">
                      {{'add-alert.send-standard-notification' | afTranslate}}
                    </span>
                  </div>
                  <button
                    class="common-button__link"
                    (click)="showPreview()">
                    <a class="common-button__link-text">
                      {{'add-alert.open-preview' | afTranslate}}
                    </a>
                  </button>
                </div>
                @if (addAlert.notifyToIdentifying && !addAlert.customTemplateSwitch) {
                  <field-type-rich-text-editable
                    class="w-full pb-lg pl-[38px]"
                    [field]="addAlert.notificationField"
                    [preSelectItem]="addAlert.comments"
                    (itemSelected)="addAlert.comments = $event.newValue">
                  </field-type-rich-text-editable>
                }
              </div>
              @if (addAlert.addAlert.when == 1) {
                <div class="flex flex-col">
                  <div
                    class="common-radio-button__radio-container"
                    (click)="changeCustomTemplateSwitch()">
                    <div class="common-button__block-button-md-checkbox">
                      <button
                        type="button"
                        class="common-button__icon-md-checkbox"
                        [ngClass]="{'common-button__icon-md-checkbox--selected': addAlert.customTemplateSwitch}">
                        <i
                          class="common-icon__md"
                          [ngClass]="addAlert.customTemplateSwitch ? 'lf-icon-radio-button-active' : 'lf-icon-step-first'">
                        </i>
                      </button>
                    </div>
                    <span class="common-button__text-md-checkbox">
                      {{'add-alert.send-custom-notification' | afTranslate}}
                    </span>
                  </div>
                  @if (addAlert.customTemplateSwitch && addAlert.snippetsLoaded) {
                    <div class="w-full flex flex-col gap-xs pl-[38px]">
                      <div class="common-container__mandatory-obligatory-message-form">
                        <span class="common-tag__mandatory-text-asterisk">*</span>
                        <span
                          class="common-tag__mandatory-label-text-obligatory-message"
                          afTranslate="common.required-fields">
                          _Campos obligatorios
                        </span>
                      </div>
                      <field-type-rich-text-editable
                        class="w-full"
                        [field]="addAlert.customNotificationField"
                        [preSelectItem]="addAlert.customTemplate"
                        (itemSelected)="addAlert.customTemplate = $event.newValue">
                      </field-type-rich-text-editable>
                      <field-type-switch
                        class="w-full py-xs"
                        [small]="true"
                        [field]="{ label: 'add-alert.allow-edit-notification' | afTranslate }"
                        [preSelectItem]="addAlert.customTemplateEditable"
                        (itemSelected)="addAlert.customTemplateEditable = $event.newValue">
                      </field-type-switch>
                    </div>
                  }
                </div>
              }
            </div>
          }
        }
      }
    </form>
  </div>
  <div class="common-modal__footer">
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        [ngClass]="{'common-button__text-noborder': addAlert.stepState === 2 || addAlert.stepState === 3}"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">
          _Cancelar
        </span>
      </button>
      @switch (addAlert.stepState){
        @case(1){
            <button class="common-button__text"
            (click)="goNext('next')">
            <span class="common-button__text-title"
              [afTranslate]="'common.next'">
              _Siguiente
            </span>
          </button>
        }
        @case(2){
          <button class="common-button__text-border"
            (click)="goBack()">
            <span class="common-button__text-title"
              [afTranslate]="'common.previous'">
              _Anterior
            </span>
          </button>
          @if (addAlert.notifyStep) {
            <button class="common-button__text"
              (click)="goNext('notify')">
              <span class="common-button__text-title"
                [afTranslate]="'common.next'">
                _Siguiente
              </span>
            </button>
          }@else {
            <button
              class="common-button__text"
              (click)="publishAlert()">
              <span class="common-button__text-title">
                {{addAlert.submitButton}}
              </span>
            </button>
          }
        }
        @default(){
          <button class="common-button__text-border"
            (click)="goBack()">
            <span class="common-button__text-title"
              [afTranslate]="'common.previous'">
              _Anterior
            </span>
          </button>
          <button class="common-button__text"
            (click)="publishAlert()">
            <span class="common-button__text-title"
              [afTranslate]="addAlert.stepState === 3 && addAlert.notifyToIdentifying?'common.create':'common.finish'">
              _finalizar
            </span>
          </button>
        }
      }
    </div>

  </div>
</div>
